module.exports = __webpack_public_path__ + "media/member-left.eafe5218.mp3";